import React from "react";
interface StatCardProps {
  title: string;
  count: number | string;
  change: number;
  trend: string;
  suffix?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  count,
  change,
  trend,
  suffix,
}) => (
  <div className="bg-white  rounded-xl border border-gray-200 flex flex-col">
    <div className="bg-gray-50 py-3 px-5">
      <h3 className="text-md font-semibold text-gray-900">{title}</h3>
    </div>
    <div className="flex  items-center px-5 py-3 gap-8 border-t border-gray-200 rounded-md">
      <p className="text-3xl font-semibold text-gray-900">
        {typeof count === "number"
          ? `${count.toLocaleString()}${suffix ? ` ${suffix}` : ""}`
          : `${count}${suffix ? ` ${suffix}` : ""}`}
      </p>
      <div
        className={` flex text-sm ${
          change >= 0 ? "text-emerald-600" : "text-red-600"
        }`}
      >
        <span>
          {change >= 0 ? "↑" : "↓"} {Math.abs(change)}%
        </span>
        <span className="text-gray-600 ml-1">vs last month</span>
      </div>
    </div>
    <div className="my-4  h-[60px] w-full">
      <svg className="w-full h-full " viewBox="0 0 200 60" fill="none">
        <path
          d={trend}
          stroke={suffix ? "#FF6A00" : change >= 0 ? "#19BFB7" : "#FF6B6B"}
          strokeWidth="2"
          fill="none"
        />
      </svg>
    </div>
  </div>
);

export default StatCard;
export type { StatCardProps };
